import striptags from 'striptags'
import { nanoid } from 'nanoid'
import type { SocialMedia } from '@/types/user'

export const randomID = () => nanoid(9)

export function formatSocialsURL(parameter: string, socialMedia: SocialMedia) {
  let parsedParameter = parameter.startsWith('@') ? parameter.slice(1) : parameter
  let finalUrl = parsedParameter

  parsedParameter = parsedParameter.replaceAll('https://', '')

  if (!parameter.includes(SOCIAL_MEDIA_URLS[socialMedia]))
    finalUrl = `${SOCIAL_MEDIA_URLS[socialMedia]}/${socialMedia === 'youtube' ? '@' : ''}${parsedParameter}`
  else if (socialMedia === 'website')
    finalUrl = `${parsedParameter}`

  if (!finalUrl.includes('https://'))
    finalUrl = `https://${finalUrl}`

  return finalUrl
}

export function cleanSocialURL(url: string) {
  let finalUrl = url

  finalUrl = finalUrl.replaceAll(/^https?:\/\//g, '')

  for (const s in SOCIAL_MEDIA_URLS) {
    const socialMedia = s as SocialMedia

    if (socialMedia === 'website')
      continue

    if (finalUrl.includes('www.'))
      finalUrl = finalUrl.replace('www.', '')

    if (finalUrl.includes(`${SOCIAL_MEDIA_URLS[socialMedia]}/`))
      finalUrl = finalUrl.replace(`${SOCIAL_MEDIA_URLS[socialMedia]}/`, '')

    if (finalUrl.startsWith('@'))
      finalUrl = finalUrl.slice(1)

    if (finalUrl.endsWith('/'))
      finalUrl = finalUrl.slice(0, -1)
  }

  return finalUrl
}

export function formatCurrency(value: number, currency: string) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(value)
}

export function formatYoutubeIframeURL(url: string) {
  if (url.includes('youtube.com/embed'))
    return url

  let videoId = ''
  if (url.includes('youtu.be'))
    videoId = url.split('youtu.be/')[1]?.split('&')[0]
  else
    videoId = url.split('watch?v=')[1]?.split('&')[0]

  return `https://www.youtube.com/embed/${videoId}`
}

export function stripHTMLDescription(html: string) {
  return striptags(html, ['strong', 'em'])
}
